import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { FragmentCardTime } from './FragmentCardTime';
import { FragmentMediaPill } from './FragmentMediaPill';

/**
 * Pill showing fragment start time. Used as overlay on audio/video card media.
 */
export function FragmentCardTimePill({ fragment }: { fragment: FragmentListItemDto }) {
  return (
    <FragmentMediaPill>
      <FragmentCardTime from={fragment.from} />
    </FragmentMediaPill>
  );
}
